export default __webpack_public_path__ + "static/media/oscer-pres-ear-pain.7668f7ea.svg";